import { format, parse } from 'date-fns'
import { graphql, useStaticQuery } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import React from 'react'
import Layout from '../../../components/Layout'
import SEO from '../../../components/SEO'
import './PrivacyPolicy.scss'

const PrivacyPolicy = () => {
  const {
    mdx: {
      body,
    },
    file: {
      fields: {
        gitLogLatestDate,
      },
    },
  } = useStaticQuery(graphql`
    query PrivacyPolicyQuery {
      mdx(fields: { title: { eq: "PrivacyPolicy" } } ) {
        body
      }
      file(name: { eq: "PrivacyPolicy" } ) {
        fields {
          gitLogLatestDate
        }
      }
    }
  `)

  const lastModified = parse(gitLogLatestDate, `yyyy-MM-dd HH:mm:ss XX`, new Date())

  return (
    <Layout>
      <SEO
        title="Privacy Policy"
      />
      <div className="privacy-policy-page">
        <MDXRenderer>{body}</MDXRenderer>
        <div className="last-modified">
          <span>Last modified: {format(lastModified, `do LLLL yyyy`)}</span>
        </div>
      </div>
    </Layout>
  )
}

export default PrivacyPolicy